import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daemkeptto0ceqqnh030";

export default function ContactSection() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = (fd.get("website_alt") as string) || "";
    if (honeypot.trim() !== "") {
      setStatus("success");
      return;
    }

    setStatus("loading");
    setFormError("");
    const payload = new URLSearchParams();
    fd.forEach((value, key) => {
      if (key === "website_alt") return;
      payload.append(key, value as string);
    });

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (res.ok && code === "OK") {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(typeof msg === "string" ? msg : "提交失败，请稍后重试");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后重试");
    }
  };

  return (
    <section id="contact" className="relative scroll-mt-20 py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* info */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold uppercase tracking-wider">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              联系我们
            </div>
            <h2 className="mt-3 font-heading font-extrabold text-foreground-950 text-2xl md:text-4xl tracking-tight">
              有线索？有好内容？
              <span className="text-primary-600">欢迎来投稿</span>
            </h2>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl">
              无论是你发现的行业动态、值得推荐的作品，还是希望洽谈的商务合作，都可以通过表单告诉我们。内容经编辑核实后择优收录，并标注来源。
            </p>

            <ul className="mt-8 space-y-4">
              <li className="flex items-start gap-3">
                <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-primary-100 text-primary-600 shrink-0">
                  <i className="ri-mail-line text-xl w-5 h-5 flex items-center justify-center"></i>
                </span>
                <div>
                  <p className="text-sm text-foreground-400">投稿与建议</p>
                  <p className="font-medium text-foreground-900">tougao@jiuse-baoliao.example</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-accent-100 text-accent-800 shrink-0">
                  <i className="ri-briefcase-line text-xl w-5 h-5 flex items-center justify-center"></i>
                </span>
                <div>
                  <p className="text-sm text-foreground-400">商务合作与授权</p>
                  <p className="font-medium text-foreground-900">cooperate@jiuse-baoliao.example</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-background-200 text-foreground-600 shrink-0">
                  <i className="ri-time-line text-xl w-5 h-5 flex items-center justify-center"></i>
                </span>
                <div>
                  <p className="text-sm text-foreground-400">内容团队值班</p>
                  <p className="font-medium text-foreground-900">工作日 9:00 - 21:00，热门事件随时响应</p>
                </div>
              </li>
            </ul>
          </div>

          {/* form */}
          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="font-heading font-bold text-xl text-foreground-950">投稿与联系表单</h3>
            <p className="mt-1 text-sm text-foreground-500">我们会在核实后尽快回复你（请勿填写个人私密信息）。</p>

            {status === "success" && (
              <div className="mt-5 flex items-center gap-3 rounded-lg bg-primary-50 border border-primary-200 px-4 py-3 text-sm text-primary-700">
                <i className="ri-checkbox-circle-line text-xl w-5 h-5 flex items-center justify-center"></i>
                提交成功，感谢你的关注与信任，我们会尽快处理！
              </div>
            )}
            {status === "error" && (
              <div className="mt-5 flex items-start gap-3 rounded-lg bg-accent-100 border border-accent-300 px-4 py-3 text-sm text-accent-900">
                <i className="ri-error-warning-line text-xl w-5 h-5 flex items-center justify-center shrink-0"></i>
                {formError}
              </div>
            )}

            <form className="mt-6 space-y-4" onSubmit={submit} data-readdy-form>
              {/* honeypot */}
              <div className="hp-field">
                <label>
                  <span>网站名称</span>
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </label>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5" htmlFor="name">怎么称呼你</label>
                  <input
                    id="name"
                    name="称呼"
                    type="text"
                    required
                    placeholder="例如：小李"
                    className="w-full px-3.5 py-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 focus:bg-background-50"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5" htmlFor="email">联系邮箱</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    placeholder="you@example.com"
                    className="w-full px-3.5 py-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 focus:bg-background-50"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5" htmlFor="type">留言类型</label>
                <select
                  id="type"
                  name="类型"
                  defaultValue="投稿线索"
                  className="w-full px-3.5 py-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:bg-background-50"
                >
                  <option>投稿线索</option>
                  <option>商务合作</option>
                  <option>转载授权</option>
                  <option>意见建议</option>
                  <option>其他</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5" htmlFor="content">留言内容</label>
                <textarea
                  id="content"
                  name="内容"
                  required
                  maxLength={500}
                  rows={5}
                  placeholder="请简要描述你的线索或合作意向（不超过 500 字）…"
                  className="w-full px-3.5 py-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 focus:bg-background-50 resize-none"
                ></textarea>
                <p className="mt-1 text-right text-xs text-foreground-400">最多 500 字</p>
              </div>

              <button
                type="submit"
                disabled={status === "loading"}
                className="w-full py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 disabled:opacity-60 transition-colors whitespace-nowrap"
              >
                {status === "loading" ? "正在提交…" : "提交留言"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}